import BaseAPI from "..";

export class homeAPI extends BaseAPI {
    static async getStatsAPI() {
        return await (await this.getRequest('totalstats')).data.response;
    }

    static async getCauseCategoryAPI() {
        return await (await this.getRequest('cause_category/totalstats')).data.response;
    }
  
}